import BaseModel from '../core/BaseModel';
//import VehicleCategoryModel from '@/models/VehicleCategoryModel'
import constants from '../core/Constants';

var getContants = constants.getConstans();

export default class CareReminderModel extends BaseModel {

    constructor() {
        super({
                name: "care_reminder",
                tableName: 'care_reminder',
                label: "Rental Car Maintenance"
            },
            {
                // check_box: {
                //     name: "check_box",
                //     label: " ",
                //     type: "Computed",
                //     custom: 'CheckBoxSelect',
                //     computed: (data) => {
                //         data.stt = '';
                //     },
                //     filter: {}
                // },
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                vehicle_category_name: {
                    name: "vehicle_category_name",
                    label: "Vehicle category",
                    type: "Computed",
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.vehicle_category_name = "";
                    },
                },
                license_plate_number: {
                    name: "license_plate_number",
                    label: "License plate number",
                    type: "Computed",
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.license_plate_number = "";
                    },
                },
                contact_name: {
                    name: "contact_name",
                    label: "Renter name",
                    type: "Computed",
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.contact_name = "";
                    },
                },
                contact_phone: {
                    name: "contact_phone",
                    label: "Phone",
                    type: "Computed",
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.contact_phone = "";
                    },
                },
                code_order: {
                    name: "code_order",
                    label: "Rental Order ID",
                    type: "Computed",
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.code_order = "";
                    },
                },

                booking_status_key: {
                    name:'booking_status_key',
                    label:'RO Status',
                    type: "Selection",
                    custom: 'SelectionText',
                    options: getContants.LIST_STATUS_RENTAL_ORDER,
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"small-col txt-left",
                    computed: (data) => {
                        data.booking_status_key = '';
                    },
                },
                //Renter name	Phone	Rental Order ID	RO Status	Km need to be maintened	Maitenance date	Notes

            
        

                  maitenance_date: {
                    name: 'maitenance_date',
                    type: "Date",
                    width: 15,
                    label: 'Maintenance date',
                    class:"center txt-small-col-midle txt-left",
                     //filter: { type: 'DateRange', match: 'equals' }
                   filter: { type: 'DateRange', match: 'contains'},
                },
                next_maitenance_date: {
                    name: 'next_maitenance_date',
                    type: "Date",
                    width: 15,
                    label: 'Next maintenance date',
                    class:"center txt-small-col-midle txt-left",
                     //filter: { type: 'DateRange', match: 'equals' }
                   filter: { type: 'DateRange', match: 'contains'},
                },
                note: {
                    name: 'note',
                    type: "String",
                    label: 'Notes',
                    class:"large-col txt-left txt-ellipsis-3-line",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                is_send_notification_key: {
                    name: "is_send_notification_key",
                    label: "Send notification",
                    type: "Computed",
                    custom: 'CheckToggleSelect',
                    class:"center",
                    computed: (data) => {
                        data.stt = '';
                    },
                    filter: {}
                },
                detail_get: {
                    refs:  'rental_order_id vehicle_category_id car_for_rent_id renter_id contact_name contact_phone contact_email is_send_notification  obj_rental_order_rent { vehicle_category_name vehicle_category_id license_plate_number car_for_rent_id contact_phone contact_name obj_rental_order { code booking_status } } ',
                    display: false
                },
                detail_get_2: {
                    refs:  'obj_vehicle_category{ name} obj_car_for_rent{ license_plate_number}  obj_renter{fullname phone}',
                    display: false
                },
            }
        )
    }
}
